<ng-template [ngxPermissionsOnly]="['contacts:can_get_contacts_reports_sold_times']">
  <div class="box-row panel panel-default">
    <div class="panel-body text-center text-alpha">
      <div *ngIf="!isCountLoaded" class="whirl standard spinnermargin"></div>
      <ng-template [ngIf]="isCountLoaded">
        <div class="text-lg mo">{{contactsSoldCount}}</div>
        <p>{{widgetTitle}}</p>
        <div class="mb-lg"></div>
      </ng-template>
    </div>
  </div>
</ng-template>
